import React from "react";

const PositionFilterDropdown = ({
  positions,
  filters,
  positionFilterText,
  onPositionToggle,
  onAllPositionsToggle,
}) => {
  return (
    <>
      <div className="flex items-center justify-between mb-4">
        <span className="text-[#0A0F2D] text-base font-bold">
          Filter by positions: {positionFilterText}
        </span>
      </div>

      <div className="flex items-center justify-between mb-4">
        <span className="text-[#0A0F2D] text-base">All Positions</span>
        <button
          onClick={onAllPositionsToggle}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
            filters.allPositionsSelected ? "bg-[#2283FF]" : "bg-gray-200"
          }`}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
              filters.allPositionsSelected ? "translate-x-6" : "translate-x-1"
            }`}
          />
        </button>
      </div>

      <div className="space-y-2">
        {positions.map((position) => {
          const positionId = position.id || position.name || position;
          const positionName = position.name || position;

          return (
            <div
              key={positionId}
              className="flex items-center gap-3 p-2 hover:bg-gray-50 rounded"
            >
              <input
                type="checkbox"
                checked={filters.selectedPositions.includes(positionId)}
                onChange={() => onPositionToggle(positionId)}
                className="text-[#2283FF]"
              />
              <span className="text-[#0A0F2D] text-base">{positionName}</span>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default PositionFilterDropdown;
